import { printInboundArrivalPackageLabels } from "./inboundApi";

export async function reprintInboundReceiveArrivalPackageLabel(input: {
  arrivalId: string;
  packageId: string;
  printer: string;
}): Promise<void> {
  const printer = input.printer.trim();
  if (printer === "") {
    throw new Error("Pick a label printer first.");
  }
  await printInboundArrivalPackageLabels({
    arrivalId: input.arrivalId,
    printer,
    packageId: input.packageId,
  });
}
